import { graphql } from "gatsby"
import React from "react"

import Script from "@molecules/Script/Script"

const ScriptBlock = ({ blockDataScript }) => {
  const { script, widebool, disableMinHeight } = blockDataScript || {}

  return (
    <Script
      script={script}
      wide={widebool}
      disableMinHeight={disableMinHeight}
    />
  )
}

export const query = graphql`
  fragment Script on WpBlockAcfScript {
    __typename
    blockDataScript {
      widebool
      disableMinHeight
      script
    }
  }
`
export default ScriptBlock
